import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/user.svg'


const _withScopeId = n => (_pushScopeId("data-v-7914c1a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "header",
  class: "header"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "로그인",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  ref: "catchPhrase",
  class: "catch-phrase"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "tutorial" }
const _hoisted_9 = { class: "tutorial-section" }
const _hoisted_10 = {
  class: "sign-up",
  role: "region",
  "aria-labelledby": "signup-section"
}
const _hoisted_11 = ["href", "onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "horizontal-bar",
  role: "separator",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_13 = {
  ref: "footer",
  role: "contentinfo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          "aria-label": "페이지 상단으로 이동",
          onClick: $setup.scrollToTop
        }, [
          _createElementVNode("img", {
            class: "img-logo",
            src: $setup.logoPath,
            alt: $setup.serviceInfo?.name ? `${$setup.serviceInfo.name} 로고` : '서비스 로고'
          }, null, 8 /* PROPS */, _hoisted_2)
        ]),
        _createElementVNode("button", {
          class: "img-my-page",
          type: "button",
          "aria-label": "로그인 페이지로 이동",
          onClick: $setup.goToLogin
        }, [..._hoisted_4])
      ], 512 /* NEED_PATCH */),
      ($setup.isPublicLineApi && $setup.shouldFixSearchInput)
        ? (_openBlock(), _createBlock($setup["SearchInput"], {
            key: 0,
            class: "search-wrapper",
            name: "searchInput",
            isSearchIconRight: true,
            fixed: $setup.shouldFixSearchInput,
            readonly: true,
            emphasis: true,
            "aria-label": "노선 검색하기",
            onOnClickSearchInput: $setup.goToSearch
          }, null, 8 /* PROPS */, ["fixed"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        ref: "container",
        class: "container",
        onScroll: $setup.onScrollEvent
      }, [
        _createElementVNode("main", {
          class: _normalizeClass(["search", {
          'only-search': $setup.isPublicLineApi && !$setup.isPublicTalkApi,
          'only-talk': !$setup.isPublicLineApi && $setup.isPublicTalkApi,
        }]),
          role: "main",
          "aria-labelledby": "main-content"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", {
              ref: "catchPhraseFirst",
              class: _normalizeClass(["catch-phrase--first", { hide: $setup.shouldHideCatchPhraseFirst }]),
              innerHTML: $setup.catchPhrases[0] ?? ''
            }, null, 10 /* CLASS, PROPS */, _hoisted_6),
            _createElementVNode("h2", {
              ref: "catchPhraseSecond",
              class: _normalizeClass(["catch-phrase--second", { hide: $setup.shouldHideCatchPhraseSecond }]),
              innerHTML: $setup.catchPhrases[1] ?? ''
            }, null, 10 /* CLASS, PROPS */, _hoisted_7)
          ], 512 /* NEED_PATCH */),
          ($setup.isPublicLineApi && !$setup.shouldFixSearchInput)
            ? (_openBlock(), _createBlock($setup["SearchInput"], {
                key: 0,
                class: "search-wrapper",
                name: "searchInput",
                isSearchIconRight: true,
                fixed: $setup.shouldFixSearchInput,
                readonly: true,
                emphasis: true,
                "aria-label": "노선 검색하기",
                onOnClickSearchInput: $setup.goToSearch
              }, null, 8 /* PROPS */, ["fixed"]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        ($setup.isPublicTalkApi)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: _normalizeClass(["tutorial-wrapper", {
          'search-wrapper-fixed': $setup.shouldFixSearchInput,
          'only-talk': !$setup.isPublicLineApi && $setup.isPublicTalkApi,
        }]),
              role: "region",
              "aria-labelledby": "tutorial-section"
            }, [
              _createElementVNode("div", _hoisted_8, [
                ($setup.isPublicLineApi && $setup.isPublicTalkApi)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["indicator-wrapper", { 'indicator-hide': $setup.shouldHideIndicator }]),
                      "aria-hidden": "true"
                    }, [
                      _createVNode($setup["GestureIndicator"], {
                        class: "indicator",
                        "aria-hidden": "true"
                      })
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["img-tutorial", { 'indicator-hide': $setup.shouldHideIndicator }]),
                    role: "img",
                    "aria-label": "서비스 사용 안내"
                  }, [
                    _createVNode($setup["Tutorial"], {
                      class: "tutorial-container",
                      guideInfo: $setup.guideInfo
                    }, null, 8 /* PROPS */, ["guideInfo"])
                  ], 2 /* CLASS */)
                ]),
                _createElementVNode("article", _hoisted_10, [
                  _createVNode($setup["BaseButton"], {
                    class: "btn-sign-up",
                    title: "회원가입",
                    "aria-label": "회원가입 시작하기",
                    onClick: $setup.onClickSignUp
                  }),
                  _createVNode($setup["RouterLink"], {
                    to: { name: $setup.RouterName.Login },
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate, href }) => [
                      _createElementVNode("a", {
                        class: "sign-in",
                        href: href,
                        onClick: _withModifiers(($event: any) => (navigate()), ["prevent"])
                      }, " 이미 회원이신가요? 로그인 ", 8 /* PROPS */, _hoisted_11)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"]),
                  _hoisted_12
                ])
              ])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("footer", _hoisted_13, [
          _createVNode($setup["CompanyInfo"], {
            class: _normalizeClass({ 'only-search': $setup.isPublicLineApi && !$setup.isPublicTalkApi }),
            termsList: $setup.termsList,
            onOnClickTerms: $setup.onClickTerms
          }, null, 8 /* PROPS */, ["class", "termsList"])
        ], 512 /* NEED_PATCH */)
      ], 544 /* NEED_HYDRATION, NEED_PATCH */),
      ($setup.container)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 1,
            container: $setup.container
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowTerms,
        onBackHandler: () => $setup.toggleShowTerms(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["TermsDetail"], {
            title: $setup.selectedTerms?.title ?? '',
            url: $setup.selectedTerms?.url ?? '',
            role: "dialog",
            "aria-modal": "true",
            "aria-label": 
          $setup.selectedTerms?.title
            ? `${$setup.selectedTerms.title} 상세 내용`
            : '약관 상세 내용'
        ,
            onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowTerms(false)))
          }, null, 8 /* PROPS */, ["title", "url", "aria-label"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}